import type { IntermediaryEnum } from '@bambi/api-client/schemas';
import { useContext } from 'react';

import { usePayerTripRequiredField } from '../usePayerTripRequiredField';
import { DynamicFieldNameRootContext } from './DynamicFieldNameRootContext';
import { useAppSelector } from 'src/app/store/hooks';
import { FormField } from 'src/common/FormField';
import { FormFieldController } from 'src/common/FormField/FormFieldController';
import { intermediaryDisplayName } from 'src/features/trip/management/TripImportedBadge';

export function ExternalTripId() {
  const fieldNameRoot = useContext(DynamicFieldNameRootContext);
  const selectedPayer = useAppSelector((state) => state.addATrip.selectedPayer);
  const selectedTrip = useAppSelector((state) => state.addATrip.selectedTrip);
  const hasIntermediary = Boolean(selectedTrip?.intermediary);
  const intermediaryName = selectedTrip?.intermediary
    ? intermediaryDisplayName(selectedTrip.intermediary as IntermediaryEnum)
    : undefined;

  const isCloning = Boolean(selectedTrip && !selectedTrip.id);
  const originalExternalTripId = selectedTrip?.external_trip_id;

  const helperText =
    hasIntermediary && !isCloning
      ? `This trip ID was set by ${intermediaryName} and can't be changed.`
      : isCloning && originalExternalTripId
        ? `The original trip's ID: ${originalExternalTripId}`
        : undefined;

  const isExternalTripIdRequired = usePayerTripRequiredField(
    'external_trip_id',
    selectedPayer
  );

  return (
    <>
      {selectedPayer?.payer_type === 'broker' && (
        <>
          <div className="col-span-12 flex flex-col">
            <FormFieldController
              name={`${fieldNameRoot}.external_trip_id`}
              rules={{
                required: isExternalTripIdRequired
                  ? 'External Trip ID is required'
                  : undefined,
              }}
            >
              {({ field, fieldState }) => {
                return (
                  <FormField
                    type="text"
                    label="External Trip ID"
                    error={fieldState.error?.message?.toString()}
                    helperText={
                      helperText
                        ? {
                            text: helperText!,
                            presentation: {
                              type: 'tooltip',
                              position: 'absolute w-40',
                            },
                          }
                        : undefined
                    }
                    inputProps={{
                      id: `${fieldNameRoot}.external_trip_id`,
                      ...field,
                      placeholder: 'Trip ID',
                      disabled: hasIntermediary && !isCloning,
                    }}
                  />
                );
              }}
            </FormFieldController>
          </div>
        </>
      )}
    </>
  );
}
